"use strict";

 angular.module('config', [])

.constant('AWS', {prefix:'https://s3-us-west-2.amazonaws.com/ribyt/cdn/'})

.constant('ENV', {name:'production',apiEndpoint:'https://register-api.concierge.com/api/1.0',helloSignKey:'a8614f371d546d26aac7bac2b377a339',featureToggles:{agreement:['5c5d923c3273088949305171','5b294c6f828ab21da4ab4d0d','5bae5ce8828ab21da4fc8deb','5a552d22828ab21da407fdeb','5a8f5692828ab21da4abe2d8','5aa002b2828ab21da4b551cc','5b33ce14828ab21da4534b42','5a2572be828ab21da40641ff','59283bec828ab21da49d94e7','5a67b056828ab21da43d83e9','5bc77d63327308894962fe03']}})

;